import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { fadeUp } from "../lib/motion";

const items = [
  {
    q: "What exactly does Chadow Marketing do?",
    a: "We build the backend of creator businesses: monetization systems, offer structure, conversion flows, and the operational infrastructure required for growth.",
  },
  {
    q: "Is this marketing, operations, or strategy?",
    a: "It sits across all three. The work is designed to improve how the business converts, sells, delivers, and scales.",
  },
  {
    q: "Do you replace the creator-facing brand?",
    a: "No. The creator stays front-facing. That is the point. We work behind the scenes to strengthen the business behind the audience.",
  },
  {
    q: "Is this for creators who are just getting started?",
    a: "No. This is for creators who already have traction, trust, and real demand, but need stronger systems behind the business.",
  },
  {
    q: "What kinds of creators are the best fit?",
    a: "Creators with an established audience, validated offers or monetization potential, and clear backend friction—especially where growth is outpacing infrastructure.",
  },
  {
    q: "Is this done-for-you or advisory?",
    a: "It depends on the engagement, but the focus is practical implementation—not just high-level advice.",
  },
  {
    q: "Do you work with everyone who applies?",
    a: "No. Chadow Marketing is selective. Fit matters because the work is close, strategic, and high-leverage.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 lg:py-44 bg-[#101116] border-y border-[#282930]"
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-[1500px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <motion.div {...fadeUp} className="flex items-center gap-3 mb-6">
              <span className="eyebrow">08 — FAQ</span>
              <span className="block w-8 h-px bg-[#282930]" />
            </motion.div>
            <motion.h2
              {...fadeUp}
              className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight"
            >
              Frequently {" "}
              <span className="italic text-[#C9A26B]">asked.</span>
            </motion.h2>
            <motion.p {...fadeUp} className="mt-6 text-[#A8A39D] leading-relaxed max-w-[40ch]">
              Quiet answers to the loudest questions. If yours isn&rsquo;t here,
              the application is the right place to surface it.
            </motion.p>
          </div>

          <div className="lg:col-span-8" data-testid="faq-accordion">
            <Accordion type="single" collapsible className="w-full">
              {items.map((it, i) => (
                <AccordionItem
                  key={it.q}
                  value={`item-${i}`}
                  className="border-b border-[#282930]"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-[#F4EFE6] hover:text-[#C9A26B] hover:no-underline py-6 [&[data-state=open]]:text-[#C9A26B]">
                    <span className="flex items-baseline gap-5">
                      <span className="eyebrow text-[#A8A39D] text-[10px] tabular-nums">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {it.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-[#A8A39D] leading-relaxed text-base pb-8 pl-12 pr-2 max-w-[68ch]">
                    {it.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
